module.exports = __webpack_public_path__ + "img/day6.a7cc6eb9.jpeg";